<template>
  <div>
    <div>
      <div v-if="type == 1">
        <div class="item">
          <el-radio v-model="stateMale" :label="1">直接进入应用</el-radio>
          <el-radio v-model="stateMale" :label="2">跳到注册第三步</el-radio>
        </div>
      </div>
      <div v-if="type == 2">
        <div class="item">
          <p class="sex">男生：</p>
          <div class="checkbox">
            <el-radio v-model="stateMale" :label="1">直接进入</el-radio>
            <el-radio v-model="stateMale" :label="2">付费后进入</el-radio>
          </div>
        </div>
        <div class="item">
          <p class="sex">女生：</p>
          <div class="checkbox">
            <el-radio v-model="stateFemale" :label="1">直接进入</el-radio>
            <el-radio v-model="stateFemale" :label="2">付费后进入</el-radio>
          </div>
        </div>
      </div>
      <div v-if="type == 3">
        <div class="item">
          <p class="sex">男生：</p>
          <div class="checkbox">
            <el-radio v-model="stateMale" :label="1">直接进入应用</el-radio>
            <el-radio v-model="stateMale" :label="2">付费后进入</el-radio>
            <el-radio v-model="stateMale" :label="3">人脸识别进入</el-radio>
            <el-radio v-model="stateMale" :label="4">邀请码进入</el-radio>
          </div>
        </div>
        <div class="item">
          <p class="sex">女生：</p>
          <div class="checkbox">
            <el-radio v-model="stateFemale" :label="1">直接进入应用</el-radio>
            <el-radio v-model="stateFemale" :label="2">付费后进入</el-radio>
            <el-radio v-model="stateFemale" :label="3">人脸识别进入</el-radio>
            <el-radio v-model="stateFemale" :label="4">邀请码进入</el-radio>
          </div>
        </div>
      </div>
      <div v-if="type == 4">
        <div class="item">
          <p class="sex">男生：</p>
          <div class="checkbox">
            <el-radio v-model="stateMale" :label="0">不校验</el-radio>
            <el-radio v-model="stateMale" :label="1">校验</el-radio>
          </div>
        </div>
        <div class="item">
          <p class="sex">女生：</p>
          <div class="checkbox">
            <el-radio v-model="stateFemale" :label="0">不校验</el-radio>
            <el-radio v-model="stateFemale" :label="1">校验</el-radio>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="submit" v-loading="loading">提交</el-button>
    </div>
  </div>
</template>

<script>
import { postFormData } from "@/api/api"
import { updateChannelPowerConfig} from "@/api/url";
import {urlReg} from "@/assets/shared/reg-constant";

export default {
  name: "channelControlDialog",
  props: {
    value: Object
  },
  data() {
    return {
      idArray: this.value.idArray,
      type: this.value.type,
      loading: false,
      state: '',
      stateMale: '',
      stateFemale: '',
    }
  },
  methods: {

    /**
     * 获取时间
     * @author Dave
     */
    getStartTime(el) {
      this.versionForm.startTime = el;
    },
    getEndTime(el) {
      this.versionForm.endTime = el;
    },

    cancel() {
      this.$emit("close");
    },

    submit() {
      if(this.type == 1){
        if(!this.stateMale){
          this.$message({
            showClose: true,
            duration: 1000,
            message: '选项不能为空',
            type: 'warning'
          })
          return false
        }
      }else {
        if(!this.stateMale){
          this.$message({
            showClose: true,
            duration: 1000,
            message: '请选择“男生”选项',
            type: 'warning'
          })
          return false
        }
        if(!this.stateFemale){
          this.$message({
            showClose: true,
            duration: 1000,
            message: '请选择“女生”选项',
            type: 'warning'
          })
          return false
        }
      }
      this.loading = true
      let param = {}
      param['idArr'] = this.idArray
      param['type'] = this.type;
      param['stateMale'] = this.stateMale;
      if(this.type == 1) {
        param['stateFemale'] = 0;
      }else {
        param['stateFemale'] = this.stateFemale;
      }
      postFormData(updateChannelPowerConfig, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.item {
  display: flex;
  margin: 20px auto 40px;
  width: 320px;
  align-items: center;
}

.sex {
  width: 100px;
  white-space: nowrap;
}
</style>
